import View from '~/app/View'

import '@/layout/theme.scss'

/**
 * Core scripts.
 */
import EventBus from '~/core/event-bus'
import Query from '~/core/query'
import '~/helpers/accessibility'

/**
 * Global CANVAS functions.
 */
window.basis = window.basis || {}
window.basis.EventBus = EventBus()
window.basis.Query = (query) => Query(query)

import lozad from 'lozad'
import { globaleInit } from '~/helpers/globale'
const observer = lozad()
observer.observe()
globaleInit()

// Header
import Header from '~/components/header/header'
import Promobar from '~/components/header/promobar'
import Navigation from '~/components/header/navigation'
import NavigationMenuDesktop from '~/components/header/navigation-menu-desktop'
import NavigationMenuMobile from '~/components/header/navigation-menu-mobile'
import SearchDesktop from '~/components/header/search-desktop'
import SearchMobile from '~/components/header/search-mobile'
import AccountSlider from '~/components/header/account-slider'
import AccountLoginRegister from '~/components/header/account-login-register'
import AccountLogin from '~/components/header/account-login'
import GlobaleSlider from '~/components/header/globale-slider'

// Footer
import Footer from '~/components/footer/footer'

// Background video and images
import BackgroundMedia from '~/components/global/background-media'

// Product card
import ProductCard from '~/components/product-card/product-card'

// Mini cart
import MiniCart from '~/components/cart/mini-cart'
import CartItem from '~/components/cart/cart-item'
import CartItemUpsell from '~/components/cart/cart-item-upsell'

// Wishlist page
import AccountPage from '~/components/account/account-page'
import AccountNav from '~/components/account/account-nav'
import WishlistItem from '~/components/account/wishlist-item'

// Global
import SalePopup from '~/components/global/sale-popup'

// Live Stream Miniplayer
import LiveStreamMiniPlayer from '~/components/global/live-stream-mini-player'

// Login Modal
import LoginModal from '~/components/global/login-modal'

// Exclusion Modal
import ExclusionModal from '~/components/global/exclusion-modal'

const layoutView = new View()
layoutView.init({
  // Add globally used components here
  Header,
  SalePopup,
  Promobar,
  Navigation,
  NavigationMenuDesktop,
  NavigationMenuMobile,
  SearchDesktop,
  SearchMobile,
  BackgroundMedia,
  MiniCart,
  AccountSlider,
  AccountLoginRegister,
  AccountLogin,
  GlobaleSlider,
  Footer,
  LiveStreamMiniPlayer,
  LoginModal,
  ExclusionModal,
})

const cartItemView = new View()
cartItemView.init({
  CartItem,
  CartItemUpsell,
})

const pageProductGrid = document.querySelector('.js-productGrid')
if (pageProductGrid) {
  removeCachedCollectionData()
  storeCollectionDataPage1()
}

/**
 * Remove cached collection data when mobile/desktop navigation is clicked
 * to prevent session storage from exceeding limit
 */
function removeCachedCollectionData() {
  const collectionHandle = pageProductGrid.dataset.collection

  // Navlist mobile
  const navListMobile = document.querySelectorAll('[js-nav-mobile="list"]')
  navListMobile.forEach(element => {
    element.addEventListener('click', () => {
      sessionStorage.removeItem(`cnvs-collection-data-${collectionHandle}`)
    })
  })

  // Navlist desktop
  const navListDesktop = document.querySelectorAll('[js-nav-desktop="list"]')
  navListDesktop.forEach(element => {
    element.addEventListener('click', () => {
      sessionStorage.removeItem(`cnvs-collection-data-${collectionHandle}`)
    })
  })
}

/**
 * Stores collection page 1 product cards in session storage which is used to
 * prevent products cards being remounted which was breaking product cards
 */
function storeCollectionDataPage1() {
  const collectionHandle = pageProductGrid.dataset.collection
  const sessionStorageData = JSON.parse(sessionStorage.getItem(`cnvs-collection-data-${collectionHandle}`))
  const currentPage = Number(pageProductGrid.dataset.currentPage)

  if (
    !sessionStorageData ||
    (typeof sessionStorageData === 'object' && Object.keys(sessionStorageData).length < 2)
  ) {
    sessionStorage.setItem(`cnvs-collection-data-${collectionHandle}`, JSON.stringify({ [currentPage]: pageProductGrid.innerHTML }))
  }
}

const productCardView = new View()
productCardView.init({
  ProductCard,
})

const backgroundMediaView = new View()

backgroundMediaView.init({
  BackgroundMedia,
})

document.addEventListener('productadded', () => {
  cartItemView.mountComponents()
})

document.addEventListener('toggleMiniCart', () => {
  document.querySelector('.js-miniCartOpen').click()
})


document.addEventListener('mountproductcards', () => {
  productCardView.mountComponents()
  backgroundMediaView.mountComponents()
})

if (window.location.pathname.includes('/apps/iwish')) {
  const wishListPageView = new View()
  wishListPageView.init({
    AccountPage,
    AccountNav,
    WishlistItem,
  })

}
